/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M20.75 3c0-1.6568-1.3431-3-3-3H4.25c-1.6568 0-3 1.3432-3 3v18c0 1.6569 1.3432 3 3 3h13.5c1.6569 0 3-1.3431 3-3v-.25H21c1.5188 0 2.75-1.2312 2.75-2.75v-6c0-1.5188-1.2312-2.75-2.75-2.75h-.25V3Zm-18 6.25h16.5V3c0-.7692-.5791-1.4033-1.3251-1.49L17.75 1.5H4.25c-.7692 0-1.4033.579-1.49 1.325L2.75 3v6.25Zm0 11.75v-.25h16.5V21l-.0101.1749c-.0866.746-.7206 1.3251-1.4899 1.3251H4.25l-.175-.0101C3.329 22.4033 2.75 21.7693 2.75 21Zm3-15.2473a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm3.9004 12.5491h1.2876L8.5166 12h-1.604L4.5 18.3018h1.2788l.523-1.3667h2.8344l.5142 1.3667ZM6.706 15.8452l1.0063-2.6631 1.0107 2.6631h-2.017ZM14.4976 12h-2.9532v6.3018h1.2261V16.377h1.6743c.6812 0 1.2261-.2198 1.6304-.6592.4043-.4395.6064-.9492.6064-1.5249 0-.5625-.2021-1.0679-.6064-1.5161-.4043-.4483-.9316-.6724-1.5864-.6724L14.4976 12Zm-.1011 3.2827h-1.6348v-2.1621h1.6919c.2944 0 .5361.1099.7295.3252.1934.2153.29.4658.29.7515 0 .2856-.101.5361-.3032.7514-.2021.2154-.4614.3252-.7822.3252l.0088.0088ZM17.7 18.3018h1.2525V12H17.7v6.3018Z"
    clipRule="evenodd"
  />,
  'MenuAPIinfoFilled'
);
